import commonTerms from '../../../src/terms/commonTerms.json';
import doulaTerms from '../../../src/terms/doulaTerms.json';
import housekeepingTerms from '../../../src/terms/housekeepingTerms.json';
import cookingTerms from '../../../src/terms/cookingTerms.json';
import nannyTerms from '../../../src/terms/nannyTerms.json';
import cleaningTerms from '../../../src/terms/cleaningTerms.json';
import salonTerms from '../../../src/terms/salonTerms.json';

export interface TermSection {
  section?: string;
  items: string[];
}

export interface ServiceTerms {
  title: string;
  content: TermSection[];
}

export const serviceTermsConfig: Record<string, ServiceTerms> = {
  doula: doulaTerms as ServiceTerms,
  housekeeping: housekeepingTerms as ServiceTerms,
  cooks: cookingTerms as ServiceTerms,
  nannies: nannyTerms as ServiceTerms,
  cleaning: cleaningTerms as ServiceTerms,
  salon: salonTerms as ServiceTerms,
};

export { commonTerms };